import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';

import { AccountLibraryState } from './account-library.state';

const getError = (state: AccountLibraryState): any => state.error;

export const selectAccountLibraryState: MemoizedSelector<object, AccountLibraryState> =
  createFeatureSelector<AccountLibraryState>('account-library');

export const getState = createSelector(selectAccountLibraryState, (state) => state);

export const getAppointment = createSelector(getState, (state) => state.appointment);

export const getAccountLibrary = createSelector(selectAccountLibraryState, (state) => {
  const search = state.search;
  if (search && search.keyword.length > 1) {
    return search.result;
  }
  return state.library ? state.library : [];
});

export const getSelectedFormGroups = createSelector(selectAccountLibraryState, (state) => {
  return state.selectedFormGroups;
});

export const getSearchForms = createSelector(selectAccountLibraryState, (state) => {
  return state.search;
});

export const previewTemplate = createSelector(
  selectAccountLibraryState,
  (state) => state.previewTemplate,
);

export const getSelectedTemplates = createSelector(selectAccountLibraryState, (state) => {
  const editableTemplates = state.editableTemplates;
  if (editableTemplates && editableTemplates.length > 0) {
    return editableTemplates;
  }
  return state.selectedTemplates;
});

export const getEditableTemplates = createSelector(selectAccountLibraryState, (state) => {
  return state.editableTemplates;
});

export const getSavedForms = createSelector(selectAccountLibraryState, (state) => {
  return state.savedForms;
});

export const isLoaded = createSelector(selectAccountLibraryState, (state) => state.isLoaded);
